/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */

function getIpdMedicalFunctionsConfig() {
  const ipd_medical__total_amount__value = (values, defaultValue) => {
    if (
      !values.medical_fee_can_reimbursed &&
      !values.medical_fee_not_reimbursed &&
      !values.inpatient_and_foods_can_reimbursed &&
      !values.inpatient_and_foods_not_reimbursed
    )
      return 0
    return Math.floor(
      (values.medical_fee_can_reimbursed || 0) +
        (values.medical_fee_not_reimbursed || 0) +
        (values.inpatient_and_foods_can_reimbursed || 0) +
        (values.inpatient_and_foods_not_reimbursed || 0),
    )
  }

  const ipd_medical__inpatient_and_foods_not_reimbursed__value = (values, defaultValue) => {
    return 0
  }

  const ipd_medical__medical_fee_not_reimbursed__value = (values, defaultValue) => {
    return 0
  }

  const ipd_medical__inpatient_and_foods_can_reimbursed__value = (values, defaultValue) => {
    return values.inpatient_and_foods_can_reimbursed || 0
  }

  const ipd_medical__medical_fee_can_reimbursed__value = (values, defaultValue) => {
    return values.medical_fee_can_reimbursed || 0
  }

  const ipd_medical__standard_cal_fee__value = (values, defaultValue) => {
    const {
      patient,
      hospital_type,
      day_amount,
      inpatient_and_foods_can_reimbursed = 0, // B9
      inpatient_and_foods_not_reimbursed = 0, // B10
      medical_fee_can_reimbursed = 0, // B11
      medical_fee_not_reimbursed = 0, // B12
    } = values
    if (patient === 'self') {
      if (hospital_type === 'โรงพยาบาลรัฐบาล') {
        return Math.floor(Math.min(1200 * day_amount, inpatient_and_foods_can_reimbursed) + medical_fee_can_reimbursed)
      } else {
        return Math.floor(
          Math.min(1200 * day_amount, inpatient_and_foods_can_reimbursed) +
            Math.min(medical_fee_can_reimbursed * 0.5, 3000),
        )
      }
    } else {
      let reimbursement = 0
      if (hospital_type === 'โรงพยาบาลรัฐบาล') {
        reimbursement = Math.min(800 * day_amount, inpatient_and_foods_can_reimbursed) + medical_fee_can_reimbursed
      } else {
        reimbursement =
          Math.min(800 * day_amount, inpatient_and_foods_can_reimbursed) +
          Math.min(medical_fee_can_reimbursed * 0.5, 3000)
      }
      return Math.floor(reimbursement)
    }
  }

  const ipd_medical__company_cal_fee__value = (values, defaultValue, user) => {
    const {
      patient,
      hospital_type,
      day_amount,
      inpatient_and_foods_can_reimbursed = 0, // B9
      inpatient_and_foods_not_reimbursed = 0, // B10
      medical_fee_can_reimbursed = 0, // B11
      medical_fee_not_reimbursed = 0, // B12
    } = values
    const { budget, meta } = user
    const { employeeLevelCode } = meta || {}
    const mapperRole = {
      131: 'group1',
      112: 'group1',
      102: 'group1',
      '09': 'group2',
      '08': 'group2',
      '07': 'group2',
      '06': 'group3',
      '05': 'group3',
      '04': 'group3',
      '03': 'group3',
      '02': 'group3',
      '01': 'group3',
    }
    const role = mapperRole[employeeLevelCode]

    if (patient === 'self') {
      if (role === 'group1') {
        return isGroupOne(values, budget)
      } else if (role === 'group2') {
        return isGroupTwo(values, budget)
      } else {
        return isAnotherGroup(values, budget)
      }
    }

    return 0
  }

  const ipd_medical__total_cal_fee__value = (values, defaultValue) => {
    if (!values.standard_cal_fee && !values.company_cal_fee) return 0
    return Math.floor((values.standard_cal_fee || 0) + (values.company_cal_fee || 0))
  }

  const ipd_medical__standard_fee_approval__value = (values, defaultValue) => {
    return Math.floor(values.standard_cal_fee || 0)
  }

  const ipd_medical__company_fee_approval__value = (values, defaultValue, user) => {
    const { budget } = user
    const autoCalValue = Math.floor(values.company_cal_fee)
    if (autoCalValue) {
      return autoCalValue >= budget ? budget : autoCalValue
    }
    return 0
  }

  const ipd_medical__total_fee_approval__value = (values, defaultValue) => {
    if (!values.standard_fee_approval && !values.company_fee_approval) return 0
    return Math.floor((values.standard_fee_approval || 0) + (values.company_fee_approval || 0))
  }

  const ipd_medical__inpatient_and_foods_can_reimbursed__disabled = (values, defaultValue) => {
    return false
  }

  const ipd_medical__medical_fee_can_reimbursed__disabled = (values, defaultValue) => {
    return false
  }

  const ipd_medical__standard_fee_approval__disabled = (values, defaultValue) => {
    if (values.hospital_type === 'โรงพยาบาลเอกชน') return true
    return false
  }

  const minimumHospitalStay = (context) => {
    const { values } = context
    const inputValues = values.inputs
    const dayAmount = inputValues['day_amount']
    if (Number(dayAmount) < 1) return false
    return true
  }

  const isGroupOne = (values, budget) => {
    const {
      patient,
      hospital_type,
      day_amount,
      inpatient_and_foods_can_reimbursed = 0, // B9
      inpatient_and_foods_not_reimbursed = 0, // B10
      medical_fee_can_reimbursed = 0, // B11
      medical_fee_not_reimbursed = 0, // B12
    } = values
    if (hospital_type === 'โรงพยาบาลรัฐบาล') {
      const autoCalValue = Math.floor(
        inpatient_and_foods_not_reimbursed + // B10
          inpatient_and_foods_can_reimbursed - // B9
          Math.min(inpatient_and_foods_can_reimbursed, 1200 * day_amount) + // - Min(B9, 1200*B7)
          medical_fee_not_reimbursed * 1, // B12 * 1 change 70% to 100% at 10/9/2024
      )

      return Math.min(budget, autoCalValue) // ไม่เกิน budget ที่มี
    } else {
      const autoCalValue = Math.floor(
        inpatient_and_foods_not_reimbursed + // B10
          inpatient_and_foods_can_reimbursed - // B9
          Math.min(inpatient_and_foods_can_reimbursed, 1200 * day_amount) + // - MIN(B9,  1200*B7)
          (medical_fee_not_reimbursed +
            Math.max(medical_fee_can_reimbursed - Math.min(medical_fee_can_reimbursed * 0.5, 3000), 0)) *
            1, // change 70% to 100% at 10/9/2024
      )

      return Math.min(budget, autoCalValue)
    }
  }

  const isGroupTwo = (values, budget) => {
    const {
      patient,
      hospital_type,
      day_amount,
      inpatient_and_foods_can_reimbursed = 0, // B9
      inpatient_and_foods_not_reimbursed = 0, // B10
      medical_fee_can_reimbursed = 0, // B11
      medical_fee_not_reimbursed = 0, // B12
    } = values
    if (hospital_type === 'โรงพยาบาลรัฐบาล') {
      const autoCalValue = Math.floor(
        Math.min(
          (inpatient_and_foods_not_reimbursed + // B10
            inpatient_and_foods_can_reimbursed - // B9
            Math.min(inpatient_and_foods_can_reimbursed, 1200 * day_amount)) *
            1, // -MIN(B9,  1200*B7))*1 change 70% to 100% at 10/9/2024

          300 * day_amount, // 300*B7
        ) +
          medical_fee_not_reimbursed * 1, // B12 *1 change 70% to 100% at 10/9/2024
      )

      return Math.min(autoCalValue, budget)
    } else {
      const autoCalValue = Math.floor(
        Math.min(
          (inpatient_and_foods_not_reimbursed + // B10
            inpatient_and_foods_can_reimbursed - // B9
            Math.min(inpatient_and_foods_can_reimbursed, 1200 * day_amount)) *
            1, // -MIN(B9,  1200*B7))*1 change 70% to 100% at 10/9/2024

          300 * day_amount, // 300*B7
        ) +
          (medical_fee_not_reimbursed +
            Math.max(medical_fee_can_reimbursed - Math.min(medical_fee_can_reimbursed * 0.5, 3000), 0)) *
            1, // ((B12 + MAX(B11 - 3000,0)) *1) change 70% to 100% at 10/9/2024
      )
      return Math.min(autoCalValue, budget)
    }
  }

  const isAnotherGroup = (values, budget) => {
    const {
      patient,
      hospital_type,
      day_amount,
      inpatient_and_foods_can_reimbursed = 0, // B9
      inpatient_and_foods_not_reimbursed = 0, // B10
      medical_fee_can_reimbursed = 0, // B11
      medical_fee_not_reimbursed = 0, // B12
    } = values
    if (hospital_type === 'โรงพยาบาลรัฐบาล') {
      const autoCalValue = Math.floor(medical_fee_not_reimbursed * 1) // change 70% to 100% at 10/9/2024
      return Math.min(autoCalValue, budget)
    } else {
      const autoCalValue = Math.floor(
        (medical_fee_not_reimbursed +
          Math.max(medical_fee_can_reimbursed - Math.min(medical_fee_can_reimbursed * 0.5, 3000), 0)) *
          1, // change 70% to 100% at 10/9/2024
      )
      return Math.min(autoCalValue, budget)
    }
  }

  const ipd_medical__inpatient_and_foods_can_reimbursed__remark = (values, defaultValue, user) => {
    const { patient } = values
    const { meta } = user
    const { employeeLevelCode } = meta || {}

    const mapperRoleName = {
      131: 'ประธานเจ้าหน้าที่บริหาร',
      112: 'รองประธานเจ้าหน้าที่บริหาร',
      102: 'ผู้ช่วยประธานเจ้าหน้าที่บริหาร',
      '09': 'ผู้อำนวยการ',
      '08': 'ผู้จัดการ',
      '07': 'เจ้าหน้าที่ จ.7',
      '06': 'เจ้าหน้าที่ จ.6',
      '05': 'เจ้าหน้าที่ จ.5',
      '04': 'เจ้าหน้าที่ จ.4',
      '03': 'เจ้าหน้าที่ จ.3',
      '02': 'เจ้าหน้าที่ จ.2',
      '01': 'เจ้าหน้าที่ จ.1',
    }
    const roleName = mapperRoleName[employeeLevelCode]

    const requestForOther = ['child', 'spouse']
    if (patient !== undefined && patient !== null) {
      if (patient === 'self') {
        return `${roleName}: ไม่เกินวันละ 1,200 บาท`
      } else if (requestForOther.includes(patient['relation'])) {
        return `${roleName}: ไม่เกินวันละ 800`
      } else {
        return ''
      }
    }
  }

  const ipd_medical__inpatient_and_foods_not_reimbursed__remark = (values, defaultValue, user) => {
    const { patient } = values
    const { meta } = user
    const { employeeLevelCode } = meta || {}
    const mapperRole = {
      131: 'group1',
      112: 'group1',
      102: 'group1',
      '09': 'group2',
      '08': 'group2',
      '07': 'group2',
      '06': 'group3',
      '05': 'group3',
      '04': 'group3',
      '03': 'group3',
      '02': 'group3',
      '01': 'group3',
    }

    const mapperRoleName = {
      131: 'ประธานเจ้าหน้าที่บริหาร',
      112: 'รองประธานเจ้าหน้าที่บริหาร',
      102: 'ผู้ช่วยประธานเจ้าหน้าที่บริหาร',
      '09': 'ผู้อำนวยการ',
      '08': 'ผู้จัดการ',
      '07': 'เจ้าหน้าที่ จ.7',
      '06': 'เจ้าหน้าที่ จ.6',
      '05': 'เจ้าหน้าที่ จ.5',
      '04': 'เจ้าหน้าที่ จ.4',
      '03': 'เจ้าหน้าที่ จ.3',
      '02': 'เจ้าหน้าที่ จ.2',
      '01': 'เจ้าหน้าที่ จ.1',
    }
    const role = mapperRole[employeeLevelCode]
    const roleName = mapperRoleName[employeeLevelCode]

    const requestForOther = ['child', 'spouse']

    if (patient !== undefined && patient !== null) {
      if (patient === 'self') {
        switch (role) {
          case 'group1':
            return `${roleName}: ส่วนเกินจากค่าห้อง/ค่าอาหารที่เบิกสิทธิ์มาตรฐาน เบิกเพิ่มได้อีก 100% ของยอดที่จ่าย`
          case 'group2':
            return `${roleName}: ส่วนเกินจากค่าห้อง/ค่าอาหารที่เบิกสิทธิ์มาตรฐาน เบิกเพิ่มได้อีก 100% ของยอดที่จ่ายและไม่เกินวันละ 300 บาท`
          default:
            return `${roleName}: ไม่มีสิทธิ์`
        }
      } else if (requestForOther.includes(patient['relation'])) {
        return `${roleName}: ไม่มีสิทธิ์`
      } else {
        return ''
      }
    }
  }

  const ipd_medical__claim_year__value = (values) => {
    if (values.receipt_date) return new Date(values.receipt_date).getFullYear().toString()
    return undefined
  }

  const ipd_medical__not_covered_amount__value = (values) => {
    if (values.bill_amount === undefined) return 0

    const amountStr = values.bill_amount.toString().replaceAll(',', '')
    const totalFeeApprovalStr = values.total_fee_approval?.toString().replaceAll(',', '')
    const amount = parseInt(amountStr)
    const totalFeeApproval = parseInt(totalFeeApprovalStr)
    const result = amount - totalFeeApproval
    return result < 0 ? 0 : result
  }

  return {
    autoCal: {
      // ...AutoCal,
      ipd_medical__inpatient_and_foods_not_reimbursed__value,
      ipd_medical__inpatient_and_foods_can_reimbursed__value,
      ipd_medical__medical_fee_not_reimbursed__value,
      ipd_medical__medical_fee_can_reimbursed__value,
      ipd_medical__standard_fee_approval__value,
      ipd_medical__standard_fee_approval__disabled,
      ipd_medical__total_amount__value,
      ipd_medical__company_fee_approval__value,
      ipd_medical__standard_cal_fee__value,
      ipd_medical__company_cal_fee__value,
      ipd_medical__total_cal_fee__value,
      ipd_medical__total_fee_approval__value,
      ipd_medical__inpatient_and_foods_can_reimbursed__disabled,
      ipd_medical__medical_fee_can_reimbursed__disabled,
      ipd_medical__inpatient_and_foods_can_reimbursed__remark,
      ipd_medical__inpatient_and_foods_not_reimbursed__remark,
      ipd_medical__claim_year__value,
      ipd_medical__not_covered_amount__value,
    },
    validate: {
      // ...validate,
      minimumHospitalStay,
    },
  }
}
